const isToggleEnabled = (value) => {
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "1" || normalized === "true";
  }

  return value === 1 || value === true;
};

const normalizePreStartChecklist = (swmsData = {}) => {
  const rawChecklist = swmsData && swmsData.pre_start_checklist && typeof swmsData.pre_start_checklist === "object"
    ? swmsData.pre_start_checklist
    : {};
  const rawData = rawChecklist && rawChecklist.data && typeof rawChecklist.data === "object"
    ? rawChecklist.data
    : {};

  const questions = Array.isArray(rawData.pre_start_questions)
    ? rawData.pre_start_questions
    : [];

  return {
    toggle: isToggleEnabled(rawChecklist.toggle) ? 1 : 0,
    data: {
      prestart_checklist_heading: rawData.prestart_checklist_heading ? rawData.prestart_checklist_heading : null,
      prestart_staff_signoff: rawData.prestart_staff_signoff ? rawData.prestart_staff_signoff : null,
      pre_start_questions: questions
    }
  };
};

const normalizeChecklistPayload = (checklist = {}) => {
  const sourceChecklist = checklist && typeof checklist === "object" ? checklist : {};
  const sourceData = sourceChecklist && sourceChecklist.data && typeof sourceChecklist.data === "object"
    ? sourceChecklist.data
    : {};

  return {
    ...sourceChecklist,
    toggle: isToggleEnabled(sourceChecklist.toggle) ? 1 : 0,
    data: {
      ...sourceData,
      pre_start_questions: Array.isArray(sourceData.pre_start_questions) ? sourceData.pre_start_questions : []
    }
  };
};

const reorderQuestionsByIndex = (questions = [], fromIndex = 0, toIndex = 0) => {
  if (!Array.isArray(questions) || fromIndex === toIndex) {
    return Array.isArray(questions) ? questions : [];
  }

  const reordered = [...questions];
  const [movedQuestion] = reordered.splice(fromIndex, 1);
  reordered.splice(toIndex, 0, movedQuestion);

  return reordered;
};

const resolveMethodOptions = (swmsData = {}) => {
  const methods = swmsData
    && swmsData.sections
    && swmsData.sections.document_project_details
    && swmsData.sections.document_project_details.data
    && Array.isArray(swmsData.sections.document_project_details.data.methods)
    ? swmsData.sections.document_project_details.data.methods
    : [];

  const mappedMethods = methods
    .filter((method = {}) => method && method.id !== undefined && method.id !== null)
    .map((method = {}) => ({
      value: Number(method.id),
      label: method.name || `Method ${method.id}`
    }));

  return [...mappedMethods, { value: 0, label: "Job Specific Question" }];
};

const resolvePreStartHeadingContent = (swmsData = {}) => {
  const headingContents = swmsData && swmsData.meta && Array.isArray(swmsData.meta.heading_contents)
    ? swmsData.meta.heading_contents
    : [];

  const preStartHeading = headingContents.find((item = {}) => {
    if (item.heading_key !== "prestart_checklist_heading") {
      return false;
    }

    return isToggleEnabled(item.active);
  });

  if (!preStartHeading || typeof preStartHeading.heading_content !== "string") {
    return "";
  }

  return preStartHeading.heading_content;
};

const reorderSwmsDataSections = (swmsData) => {
  if (!swmsData || !swmsData.sections || typeof swmsData.sections !== "object") {
    return swmsData;
  }

  const sections = swmsData.sections;
  const metaSequence = swmsData.meta && swmsData.meta.sequence ? swmsData.meta.sequence : {};
  const fixedArray = Array.isArray(metaSequence.fixed) ? metaSequence.fixed : [];
  const activeArray = Array.isArray(metaSequence.active) ? metaSequence.active : [];

  if (fixedArray.length === 0 && activeArray.length === 0) {
    return swmsData;
  }

  const seen = new Set();
  const orderedSectionEntries = [];

  const sortBySequenceOrder = (items) => {
    return [...items].sort((a, b) => (a.sequence_order || 0) - (b.sequence_order || 0));
  };

  const sortedFixed = sortBySequenceOrder(fixedArray);
  sortedFixed.forEach((seqItem) => {
    const itemKey = seqItem.item_key;
    if (!seen.has(itemKey) && Object.prototype.hasOwnProperty.call(sections, itemKey)) {
      seen.add(itemKey);
      orderedSectionEntries.push([itemKey, sections[itemKey]]);
    }
  });

  const sortedActive = sortBySequenceOrder(activeArray);
  sortedActive.forEach((seqItem) => {
    const itemKey = seqItem.item_key;
    if (!seen.has(itemKey) && Object.prototype.hasOwnProperty.call(sections, itemKey)) {
      seen.add(itemKey);
      orderedSectionEntries.push([itemKey, sections[itemKey]]);
    }
  });

  Object.keys(sections).forEach((key) => {
    if (!seen.has(key)) {
      seen.add(key);
      orderedSectionEntries.push([key, sections[key]]);
    }
  });

  return {
    ...swmsData,
    sections: Object.fromEntries(orderedSectionEntries)
  };
};

export {
  isToggleEnabled,
  normalizePreStartChecklist,
  normalizeChecklistPayload,
  reorderQuestionsByIndex,
  resolveMethodOptions,
  resolvePreStartHeadingContent,
  reorderSwmsDataSections
};
